import React, { useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import ContentLoader from 'react-content-loader';
import styles from '../css/AllNewsPage.module.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import Head from 'next/head'; // Use next/head for SEO
import EarnProgramBox from '../components/EarnProgram';
import Link from 'next/link';
import Image from 'next/image';
const AllNewsPage = ({ allnews }) => {
  const [visibleNewsCount, setVisibleNewsCount] = useState(9); // Initial count of visible news items

  const newsArticles = allnews.slice().sort((a, b) => new Date(b.date) - new Date(a.date));

  const handleShowMore = () => {
    setVisibleNewsCount(prevCount => prevCount + 9); // Increment the count by 9
  };

  const shareUrl = 'https://dailycoinmarket.com/all-news'; // Static URL for all-news page

  return (
    <div className={styles.allNewsPage}>
      <Head>
        <title>All News | DailyCoinMarket</title>
        <meta name="description" content="Stay updated with the latest cryptocurrency news from DailyCoinMarket. Read our comprehensive coverage on market trends, analysis, and more." />
        <meta name="keywords" content="cryptocurrency news, crypto market, Bitcoin news, Ethereum updates, blockchain news, crypto trends, altcoin news, DailyCoinMarket" />
        <meta property="og:url" content={shareUrl} />
        <link rel="canonical" href={shareUrl} />
        <meta property="og:title" content="All News | DailyCoinMarket" />
        <meta property="og:description" content="Stay updated with the latest cryptocurrency news from DailyCoinMarket. Read our comprehensive coverage on market trends, analysis, and more." />
        <meta property="og:image" content="https://dailycoinmarket.com/upload/default-news-image.jpg" />
        <meta property="og:type" content="website" />
      </Head>
      <Navbar />
      <EarnProgramBox />
      <div className={styles.container}>
        <h1>All Crypto Coins News</h1>
        <div className={styles.newsGrid}>
          {newsArticles.length === 0
            ? <ContentLoader
                speed={2}
                width={400}
                height={200}
                viewBox="0 0 400 200"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                className={styles.newsItem}
              >
                <rect x="0" y="0" rx="5" ry="5" width="400" height="150" />
                <rect x="0" y="160" rx="5" ry="5" width="300" height="20" />
                <rect x="0" y="190" rx="5" ry="5" width="250" height="20" />
              </ContentLoader>
            : newsArticles.slice(0, visibleNewsCount).map((article) => (
              <div key={article.id} className={styles.newsItem}>
                   <Image
    src={article.images[0]}
    alt={article.title}
    className={styles.newsImage}
    width={600} // Replace with actual width
    height={400} // Replace with actual height
  />
                <h2>{article.title}</h2>
                <p>{article.description}</p>
                <p className={styles.cryptoDate}>
                  {formatDistanceToNow(new Date(article.date), { addSuffix: true })}
                </p>
                <Link href={`/news/${article.slug}`} className={styles.readMore}>Read More</Link>
              </div>
            ))}
        </div>
        {visibleNewsCount < newsArticles.length && (
          <button className={styles.moreNewsButton} onClick={handleShowMore}>Show More</button>
        )}
      </div>
      <Footer />
    </div>
  );
};

export async function getStaticProps() {
  const response = await fetch('https://dailycoinmarket.com/get-all-news');
  const data = await response.json();

  // Helper function to parse JSON safely
  const parseJSON = (json) => {
    try {
      return JSON.parse(json);
    } catch (e) {
      console.error('Failed to parse JSON', e);
      return [];
    }
  };

  const allnews = data.map(article => ({ ...article, images: parseJSON(article.images) }));

  return {
    props: {
      allnews,
    },
    revalidate: 60, 
  };
}

export default AllNewsPage;
